<template>
  <div class="nav-wrapper">
    <template v-if="isMobile">
      <div class="m-nav-box">
        <!-- 顶部区域 -->
        <div class="m-nav-wrapper layout y-center space-between">
          <img src="../../../assets/images/icon/hum.png" alt="" class="m-nav-icon" @click="handleClick" />
          <img class="m-logo" src="../../../assets/images/logo.png" alt="logo" @click="routeLink('/')" />
          <div class="m-phone-user">
            <div v-if="!loginFlag" class="no-login" @click="mineClick"></div>
            <div v-else class="login layout y-center">
              <div class="flex-start-start stationMessage" @click="routeLink('/stationMessage')">
                <img src="../../../assets/images/icon/bell-icon.png" class="bell-icon" alt="通知" />
                <div class="red-div" v-if="newMessageCount != 0"></div>
              </div>
              <img class="m-user-img" :src="userInfo.headPortrait ?  userInfo.headPortrait + parametersHead :headImg"
                alt="头像" @click="mineClick" />
            </div>
          </div>
        </div>

        <!-- 侧边导航 -->
        <!-- 一级导航（包含二级导航） -->
        <el-drawer :visible.sync="drawer" :with-header="false" :direction="direction" :before-close="handleClose">
          <div class="item" @click="routeLink('/')">
            <span>首页</span>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="item" @click="routeLink('/sellMarket')">
            <span>市场</span>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="item" @click="marketClick">
            <span>新品</span>
            <i class="el-icon-arrow-right"></i>
            <el-drawer :visible.sync="marketDrawer" :with-header="false" :direction="direction" :append-to-body="true"
              :before-close="handleClose">
              <div class="market-content">
                <div class="market-content-title" @click="drawerBack">
                  <i class="el-icon-arrow-left"></i>
                  <span>市场</span>
                </div>
                <div class="market-content-content">
                  <div class="item" @click="routeLink('/mysteryBoxMarket')">
                    <span>盲盒</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                  <div class="item" @click="routeLink('/composeMarket')">
                    <span>合成</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                  <!-- <div @click="routeLink('/market')">
                    <img
                      src="../../../assets/images/icon/all-icon.png"
                      class="icon"
                      alt="所有"
                    />
                    <span>所有藏品</span>
                  </div>
                  <div
                    v-for="(v, k) in categoryListData"
                    :key="k"
                    @click="
                      routeLink('/market', {
                        categoryName: v.categoryName,
                        timeStamp: new Date().getTime()
                      })
                    "
                  >
                    <img :src="v.picture" class="icon" alt="图标" />
                    <span>{{ v.categoryName }}</span>
                  </div> -->
                </div>
              </div>
            </el-drawer>
          </div>

          <!-- 改动2 -->
          <div class="item" @click="daoClick">
            <span>DAO</span>
            <i class="el-icon-arrow-right"></i>
            <el-drawer :visible.sync="daoDrawer" :with-header="false" :direction="direction" :append-to-body="true"
              :before-close="handleClose">
              <div class="market-content">
                <div class="market-content-title" @click="drawerBack">
                  <i class="el-icon-arrow-left"></i>
                  <span>DAO</span>
                </div>
                <div class="market-content-content">
                  <div class="item" @click="routeLink('/dao')">
                    <span>社区</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                  <div class="item" @click="routeLink('/util-community')">
                    <span>社区工具</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                  <div class="item" @click="routeLink('/dao-welfare')">
                    <span>DAO福利</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                  <div class="item" @click="routeLink('/dao-govern')">
                    <span>DAO治理</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </div>
            </el-drawer>
          </div>
          <div class="item" @click="routeLink('/burningMobile')">
            <span>燃烧</span>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="item" @click="windowOpen('/news')">
            <span>公告</span>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="item" @click.stop="mineClick">
            <span>我的</span>
            <i class="el-icon-arrow-right"></i>
            <el-drawer :visible.sync="mineDrawer" :with-header="false" :direction="direction" :append-to-body="true"
              :before-close="handleClose">
              <div class="market-content">
                <div class="market-content-title" @click.stop="drawerBack">
                  <i class="el-icon-arrow-left"></i>
                  <span>我的</span>
                </div>
                <div class="market-content-content">
                  <div @click="routeLink('/mine')">
                    <span>我的藏品</span>
                  </div>
                  <div @click="routeLink('/setting')">
                    <span>个人中心</span>
                  </div>
                  <!-- <div @click="routeLink('/setting')">
                  <span>账户设置</span>
                </div> -->
                  <div @click="routeLink('/invitation')">
                    <span>邀请好友</span>
                  </div>
                  <div @click="loginout">
                    <span>退出</span>
                  </div>
                </div>
              </div>
            </el-drawer>
          </div>
          <div class="link flex-between-center">
            <div class="link-item flex-start-center">
              <img src="../../../assets/images/icon/qq-link-icon.png" alt="QQ" class="icon" />
              <img src="../../../assets/images/qq-code.png" alt="qq" class="qrcode" />
            </div>
            <a rel="nofollow" class="link-item flex-start-center" href="https://weibo.com/u/7725518860" target="_blank">
              <img src="../../../assets/images/icon/weibo-link-icon.png" alt="微博" class="icon" />
              <!-- <img src="../../../assets/images/weixin.jpg" alt="qq"> -->
            </a>
            <div class="link-item flex-start-center">
              <img src="../../../assets/images/icon/wechat-link-icon.png" alt="微信" class="icon" />
              <img src="../../../assets/images/wechat-code.jpg" alt="微信" class="qrcode" />
            </div>
          </div>
          <!-- </el-drawer> -->
        </el-drawer>
      </div>
    </template>
    <template v-else>
      <nav :class="{'burning': $route.name === 'burning'}">
        <header class="flex-between-center">
          <div class="phone-user">
            <div v-if="!loginFlag" class="no-login" @click="mineClick"></div>
            <div v-else class="login flex-start-center">
              <div class="flex-start-start stationMessage" @click="routeLink('/stationMessage')">
                <img src="../../../assets/images/icon/bell-icon.png" class="bell-icon" alt="通知" />
                <div class="red-div" v-if="newMessageCount != 0"></div>
              </div>
              <img :src="userInfo.headPortrait ?  userInfo.headPortrait + parametersHead :headImg" alt="头像"
                @click="mineClick" />
            </div>
          </div>
          <img class="logo" v-if="$route.name === 'burning'" src="../../../assets/images/burning/nvwa_logo.png"
            alt="logo" @click="routeLink('/')" />
          <img class="logo" v-else src="../../../assets/images/logo.png" alt="logo" @click="routeLink('/')" />
          <h1 class="hidden">女娲NVWA</h1>
          <div class="link flex-start-center">
            <!-- <div class="search">
          <i class="el-icon-search pointer"></i>
          <input type="text" placeholder="搜索项目、集合和账户" />
        </div> -->
            <div class="nav flex-between-center">
              <span class="pointer" :class="{'burning': $route.name === 'burning', 'active': activeNav == '/'}"
                @click="routeLink('/')">首页</span>

              <span class="pointer el-dropdown-link"
                :class="{'burning': $route.name === 'burning', 'active': activeNav == '/sellMarket'}"
                @click="routeLink('/sellMarket')">市场</span>

              <el-dropdown trigger="hover" class="mydropdown" :append-to-body="true" placement="top">
                <span class="pointer el-dropdown-link"
                  :class="{'burning': $route.name === 'burning', 'active': activeNav == '/market'}"
                  @click="routeLink('/market')">新品</span>
                <el-dropdown-menu>
                  <el-dropdown-item @click.native="routeLink('/mysteryBoxMarket')">
                    <span>盲盒</span>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="routeLink('/composeMarket')">
                    <span>合成</span>
                  </el-dropdown-item>
                  <!-- <el-dropdown-item
                    @click.native="routeLink('/market', { categoryName: null })"
                  >
                    <img
                      src="../../../assets/images/icon/all-icon.png"
                      class="icon"
                      alt="所有"
                    />
                    <span>所有藏品</span>
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-for="(v, k) in categoryListData"
                    :key="k"
                    @click.native="
                      routeLink('/market', {
                        categoryName: v.categoryName,
                        timeStamp: new Date().getTime()
                      })
                    "
                  >
                    <img :src="v.picture" class="icon" alt="图标" />
                    <span>{{ v.categoryName }}</span>
                  </el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>

              <!-- 改动2 -->
              <el-dropdown trigger="hover" class="mydropdown" :append-to-body="true" placement="top">
                <span class="pointer"
                  :class="{'burning': $route.name === 'burning', 'active': activeNav == '/composeMarket'}"
                  @click="routeLink('/dao')">DAO</span>
                <el-dropdown-menu>
                  <el-dropdown-item @click.native="routeLink('/dao')">
                    <span>社区</span>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="routeLink('/util-community')">
                    <span>社区工具</span>
                  </el-dropdown-item>

                  <el-dropdown-item @click.native="routeLink('/dao-welfare')">
                    <span>DAO福利</span>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="routeLink('/dao-govern')">
                    <span>DAO治理</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <span class="pointer el-dropdown-link"
                :class="{'burning': $route.name === 'burning', 'active': activeNav == '/burning'}"
                @click="routeLink('/burning')">燃烧</span>

              <span class="pointer" :class="{'burning': $route.name === 'burning', 'active': activeNav == '/news'}"
                @click="windowOpen('/news')">公告</span>
            </div>
            <i :class="drawer ? 'el-icon-s-fold' : 'el-icon-s-unfold'" @click="handleClick"></i>
            <div v-if="!loginFlag" class="user login">
              <span class="el-dropdown-link" @click="login" :class="{'burning': $route.name === 'burning'}">
                登录
                <!-- <img src="../../../assets/images/img1.png" alt="" @click="dialogShow" /> -->
              </span>
            </div>
            <div v-if="loginFlag" class="user-chuang" @click="$router.push('/createPortfolio')">创造</div>
            <div v-if="loginFlag" class="user">
              <el-dropdown trigger="click" class="mydropdown" placement="top">
                <span class="el-dropdown-link">
                  <img :src="userInfo.headPortrait ?  userInfo.headPortrait + parametersHead :headImg" alt="头像"
                    @click="dialogShow" />
                </span>
                <el-dropdown-menu>
                  <el-dropdown-item class="block" @click.native="routeLink('/mine', { tabIndex: 0 })">
                    我的藏品
                  </el-dropdown-item>
                  <el-dropdown-item class="block asdf" @click.native="routeLink('/setting')">
                    个人中心
                  </el-dropdown-item>

                  <!-- <el-dropdown-item class="block" @click="routeLink('/mine', { tabIndex: 2 })">
                  藏品集
                </el-dropdown-item> -->
                  <!-- <el-dropdown-item class="block" @click="routeLink('/copyrightIncome')">
                  版权收入
                </el-dropdown-item> -->
                  <!-- <el-dropdown-item class="block" @click.native="routeLink('/setting')">
                  账户设置
                </el-dropdown-item> -->
                  <el-dropdown-item class="block" @click.native="routeLink('/invitation')">
                    邀请好友
                  </el-dropdown-item>
                  <el-dropdown-item class="block" @click.native="loginout">退出</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div v-if="loginFlag" class="stationMessage stationMessage-pc flex-center-center">
              <el-dropdown trigger="click" class="mydropdown" :append-to-body="true" placement="top"
                @visible-change="getStationMessage">
                <img v-if="$route.name === 'burning'" src="../../../assets/images/burning/messsage.png"
                  class="bell-icon" alt="通知" />
                <img v-else src="../../../assets/images/icon/bell-icon.png" class="bell-icon" alt="通知" />
                <div class="red-div" v-if="newMessageCount != 0"></div>
                <el-dropdown-menu>
                  <div class="stationMessage-contain">
                    <div class="main">
                      <p class="title">站内信</p>
                      <div class="tab flex-between-center">
                        <div class="flex-start-center">
                          <div class="item" :class="tabIndex === 1 ? 'active' : ''" @click="tabClick(1)">
                            <span>全部</span>
                            <div class="red" v-if="newMessageCount != 0"></div>
                          </div>
                          <div class="item" :class="tabIndex === 2 ? 'active' : ''" @click="tabClick(2)">
                            <span>挂售消息</span>
                            <div class="red" v-if="newMessageConsignmentCount != 0"></div>
                          </div>
                          <div class="item" :class="tabIndex === 3 ? 'active' : ''" @click="tabClick(3)">
                            <span>最新公告</span>
                            <div class="red" v-if="newMessageActivityCount != 0"></div>
                          </div>
                          <div class="item" :class="tabIndex === 4 ? 'active' : ''" @click="tabClick(4)">
                            <span>系统消息</span>
                            <div class="red" v-if="newMessageSystemCount != 0"></div>
                          </div>
                        </div>
                      </div>
                      <div class="content flex-start-start" v-if="websiteMessageArr.length > 0">
                        <div class="table">
                          <div class="table-content">
                            <div class="item flex-start-start" v-for="(v, k) in websiteMessageArr" :key="k" @click="
                              websiteLink('/stationMessageInfo', {
                                uuid: v.id
                              })
                            ">
                              <p class="time">
                                {{ timeChange(v.releaseTime) }}
                              </p>
                              <div class="item-title">
                                <div class="unreadMessage" v-if="!v.readMessage"></div>
                                <p>{{ v.title }}</p>
                              </div>
                              <p class="des">{{ v.body }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="no-message flex-center-center" v-else>
                        <span>暂无通知</span>
                      </div>
                      <div class="more flex-center-center" @click="routeLink('/stationMessage')">
                        <p>查看全部</p>
                        <img src="../../../assets/images/icon/all-message-icon.png" alt="全部" />
                      </div>
                    </div>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </header>
        <!-- <loginComponent
      ref
      :dialog-visible="dialogVisible"
      @dialogShow="dialogShow"
      @loginout="loginout"
    ></loginComponent> -->

        <el-drawer :visible.sync="drawer" :with-header="false" :direction="direction" :before-close="handleClose">
          <!-- <el-drawer class="drawer-content"> -->
          <div class="item" @click="routeLink('/')">
            <span>首页</span>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="item" @click="marketClick">
            <span>新品</span>
            <i class="el-icon-arrow-right"></i>
            <el-drawer :visible.sync="marketDrawer" :with-header="false" :direction="direction" :append-to-body="true"
              :before-close="handleClose">
              <div class="market-content">
                <div class="market-content-title" @click="drawerBack">
                  <i class="el-icon-arrow-left"></i>
                  <span>市场</span>
                </div>
                <div class="market-content-content">
                  <div @click="routeLink('/market')">
                    <img src="../../../assets/images/icon/all-icon.png" class="icon" alt="所有" />
                    <span>所有藏品</span>
                  </div>
                  <div v-for="(v, k) in categoryListData" :key="k" @click="
                    routeLink('/market', {
                      categoryName: v.categoryName,
                      timeStamp: new Date().getTime()
                    })
                  ">
                    <img :src="v.picture+ parameters" class="icon" alt="图标" />
                    <span>{{ v.categoryName }}</span>
                  </div>
                </div>
              </div>
            </el-drawer>
          </div>

          <div class="item" @click="routeLink('/mysteryBoxMarket')">
            <span>盲盒</span>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="item" @click="routeLink('/composeMarket')">
            <span>合成</span>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="item" @click="routeLink('/sellMarket')">
            <span>市场</span>
            <i class="el-icon-arrow-right"></i>
          </div>
          <!-- <div class="item" @click="communityClick">
            <span>社区</span>
            <i class="el-icon-arrow-right"></i>
            <el-drawer
              :visible.sync="communityDrawer"
              :with-header="false"
              :direction="direction"
              :append-to-body="true"
              :before-close="handleClose"
            >
              <div class="market-content">
                <div class="market-content-title" @click="drawerBack">
                  <i class="el-icon-arrow-left"></i>
                  <span>社区</span>
                </div>
                <div class="market-content-content">
                  <div
                    @click="linkOther('https://nvwahelp.zendesk.com/hc/zh-cn')"
                  >
                    <span>帮助中心</span>
                  </div>
                  <div @click="routeLink('/about')">
                    <span>关于我们</span>
                  </div>
                </div>
              </div>
            </el-drawer>
          </div> -->
          <div class="item" @click="windowOpen('/news')">
            <span>公告</span>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="item" @click.stop="mineClick">
            <span>我的</span>
            <i class="el-icon-arrow-right"></i>
            <el-drawer :visible.sync="mineDrawer" :with-header="false" :direction="direction" :append-to-body="true"
              :before-close="handleClose">
              <div class="market-content">
                <div class="market-content-title" @click.stop="drawerBack">
                  <i class="el-icon-arrow-left"></i>
                  <span>我的</span>
                </div>
                <div class="market-content-content">
                  <div @click="routeLink('/mine')">
                    <span>我的藏品</span>
                  </div>
                  <div @click="routeLink('/setting')">
                    <span>个人中心</span>
                  </div>
                  <!-- <div @click="routeLink('/setting')">
                  <span>账户设置</span>
                </div> -->
                  <div @click="routeLink('/invitation')">
                    <span>邀请好友</span>
                  </div>
                  <div @click="loginout">
                    <span>退出</span>
                  </div>
                </div>
              </div>
            </el-drawer>
          </div>
          <div class="link flex-between-center">
            <div class="link-item flex-start-center">
              <img src="../../../assets/images/icon/qq-link-icon.png" alt="QQ" class="icon" />
              <img src="../../../assets/images/qq-code.png" alt="qq" class="qrcode" />
            </div>
            <a rel="nofollow" class="link-item flex-start-center" href="https://weibo.com/u/7725518860" target="_blank">
              <img src="../../../assets/images/icon/weibo-link-icon.png" alt="微博" class="icon" />
              <!-- <img src="../../../assets/images/weixin.jpg" alt="qq"> -->
            </a>
            <div class="link-item flex-start-center">
              <img src="../../../assets/images/icon/wechat-link-icon.png" alt="微信" class="icon" />
              <img src="../../../assets/images/wechat-code.jpg" alt="微信" class="qrcode" />
            </div>
          </div>
          <!-- </el-drawer> -->
        </el-drawer>
      </nav>
    </template>
  </div>
</template>

<script>
import {
  categoryList,
  userDetail,
  websiteMessage,
  websiteMessageNew,
  userCanCast
} from '../../../request/api.js'
import { timeChange, ossParameters, ossParameters1 } from '../../../assets/js/globle.js'
import headImg from '../../../assets/images/head.png'
export default {
  components: {},
  data() {
    return {
      parameters: ossParameters(),
      parametersHead: ossParameters1(),
      timeChange: timeChange,
      headImg: headImg,
      dialogVisible: false,
      loginFlag: false,
      drawer: false,
      direction: 'ltr',
      marketDrawer: false,
      daoDrawer: false,
      marketContentDrawer: false,
      communityDrawer: false,
      mineDrawer: false,
      categoryListData: [],
      userInfo: {},
      userCast: true,
      tabIndex: 1,
      websiteMessageArr: [],
      newMessageActivityCount: 0, // 活动新消息存在数量
      newMessageConsignmentCount: 0, // 挂售新消息
      newMessageCount: 0, // 总共新消息
      newMessageSystemCount: 0, // 系统新消息
      activeNav: '/'
    }
  },
  created() {
    // if (this.$route.query) {
    //   if (this.$route.query.token) {
    //     let token = this.$route.query.token
    //     let myToken = this.encryStr(token)
    //     localStorage.setItem('token', myToken)
    //   }
    // }
    let path = this.$route.path
    this.activeNav = path
    if (localStorage.getItem('token')) {
      this.loginFlag = true
      this.getUserInfo()
      // this.getWebMessage()
      this.getWebsiteMessageNew()
      // this.userCanCast()
    }
    window.addEventListener('storage', this.tokenAddListen)
    this.getCategoryList()
  },
  methods: {
    tabClick(index) {
      this.tabIndex = index
      let bizType = null
      // eslint-disable-next-line eqeqeq
      if (index == 1) {
        bizType = null
        // eslint-disable-next-line eqeqeq
      } else if (index == 2) {
        bizType = 2
        // eslint-disable-next-line eqeqeq
      } else if (index == 3) {
        bizType = 1
        // eslint-disable-next-line eqeqeq
      } else if (index == 4) {
        bizType = 0
      }
      this.getWebMessage(bizType)
    },
    getStationMessage(type) {
      if (!type) {
        this.tabIndex = 1
      }
      type && this.getWebMessage()
    },
    // 站内信未读数量
    getWebsiteMessageNew() {
      websiteMessageNew().then(res => {
        let obj = res.data
        this.newMessageActivityCount = obj.newMessageActivityCount
        this.newMessageConsignmentCount = obj.newMessageConsignmentCount
        this.newMessageCount = obj.newMessageCount
        this.newMessageSystemCount = obj.newMessageSystemCount
      })
    },
    // 获取站内信
    getWebMessage(bizType) {
      // 0 系统消息 1 活动消息 2 挂售消息 为空时 表示全部
      let query = {
        bizType: bizType,
        pageNo: 1,
        pageSize: 4,
        unreadMessage: false
      }
      websiteMessage(query).then(res => {
        let records = res.data.records
        for (let i = 0; i < records.length; i++) {
          // 富文本处理
          let description = records[i].body
          description = description.replace(/(\n)/g, '')
          description = description.replace(/(\t)/g, '')
          description = description.replace(/(\r)/g, '')
          description = description.replace(/<\/?[^>]*>/g, '')
          description = description.replace(/\s*/g, '')
          records[i].body = description
        }
        this.websiteMessageArr = records
      })
    },
    encryStr(str) {
      let newStr = ''
      for (let i = 0; i < str.length; i++) {
        let tmp = str.substring(i, i + 1)
        switch (tmp) {
          case 'A':
            tmp = '1'
            break
          case 'B':
            tmp = '2'
            break
          case 'C':
            tmp = '3'
            break
          case '1':
            tmp = 'A'
            break
          case '2':
            tmp = 'B'
            break
          case '3':
            tmp = 'C'
            break
        }
        newStr = newStr + tmp
      }
      return newStr
    },
    login() {
      this.$router.push({
        path: '/login'
      })
    },
    getCategoryList() {
      categoryList().then(res => {
        this.categoryListData = res.data
      })
    },
    tokenAddListen() {
      if (!localStorage.getItem('token')) {
        localStorage.removeItem('token')
        localStorage.removeItem('userVO')
        sessionStorage.removeItem('inviteData')
      }
    },
    linkOther(url) {
      window.open(url, '_blank')
    },
    windowOpen(path) {
      this.activeNav = path
      const { href } = this.$router.resolve({ path: path })
      window.open(href, '_blank')
    },
    routeLink(path, query) {
      // this.drawer = false
      // this.marketContentDrawer = false
      // this.mineDrawer = false
      if (path === '/dao-welfare') {
        this.toast('敬请期待', 'warning')
        return false
      }
      if (path === '/dao-govern') {
        this.toast('敬请期待', 'warning')
        return false
      }
      this.drawerBack()
      this.handleClick()
      this.activeNav = path
      this.$router.push({
        path: path,
        query: query
      })
    },
    toast(tips, type) {
      this.isMobile ? this.$toast(tips) : this.$message[type](tips)
    },
    websiteLink(path, query) {
      let link = this.$router.resolve({ path: path + '/' + query.uuid })
      console.log(link)
      window.open(link.href, '_blank')
    },
    getUserInfo() {
      userDetail().then(res => {
        this.userInfo = res.data.userVO
        localStorage.setItem('userVO', JSON.stringify(res.data.userVO))
      })
    },
    dialogShow() {
      if (this.loginFlag) {
        return false
      } else {
        let dialogVisible = this.dialogVisible
        this.dialogVisible = !dialogVisible
      }
      if (localStorage.getItem('token')) {
        this.loginFlag = true
        this.getUserInfo()
      }
    },
    loginout() {
      this.loginFlag = false
      localStorage.removeItem('token')
      localStorage.removeItem('userVO')
      sessionStorage.removeItem('inviteData')
      this.$store.commit('REMOVE_SELLMARKET')
      this.$store.commit('REMOVE_COMMUNITY_ID')
      if (this.isMobile) {
        this.$toast('退出成功')
      } else {
        this.$message({
          type: 'success',
          message: '退出成功'
        })
      }
      // setTimeout(() => {
      //   this.$router.push({
      //     path: '/'
      //   })
      // }, 1000)
    },
    handleClick() {
      let drawer = this.drawer
      console.log(drawer)
      this.drawer = !drawer
      if (!this.drawer) {
        this.mineDrawer = false
        this.marketDrawer = false
        this.daoDrawer = false
        this.communityDrawer = false
      }
    },
    marketClick() {
      this.marketDrawer = true
    },
    daoClick() {
      this.daoDrawer = true
    },
    communityClick() {
      this.communityDrawer = true
    },
    drawerBack() {
      this.marketDrawer = false
      this.daoDrawer = false
      this.mineDrawer = false
      this.communityDrawer = false
      this.drawer = true
    },
    handleClose() { },
    mineClick() {
      // this.drawer = false
      // this.mineDrawer = true
      if (this.loginFlag) {
        let mineDrawer = this.mineDrawer
        this.drawer = true
        this.mineDrawer = !mineDrawer
      } else {
        this.$router.push({
          path: '/login'
        })
        // this.dialogVisible = true
        // let dialogVisible = this.dialogVisible
        // this.dialogVisible = !dialogVisible
      }
    }
  }
}
</script>

<!-- 移动端样式 -->
<style lang="scss" scoped>
.nav-wrapper {
  position: relative;
}


.m-nav-box {
  border-bottom: 1px solid #e7e7e7;
  position: fixed;
  top: 0;
  background: rgba($color: #ffffff, $alpha: 1.0);
  z-index: 3000;
  width: 100%;
}


.m-nav-wrapper {
  width: 100%;
  height: 56px;
  padding: 0 20px;
  background: rgba($color: #ffffff, $alpha: 1.0);

  .m-nav-icon {
    width: 15px;
    height: 16px;
    background-size: 100% 100%;
  }


  .m-logo {
    width: 92px;
    // height: 30px;
    background-size: 100% 100%;
  }


  .m-phone-user {
    .no-login {
      width: 21px;
      height: 21px;
      background: #f7e1cd;
      border-radius: 11px;
    }


    .login {
      .stationMessage {
        position: relative;
      }


      .m-user-img {
        margin-left: 15px;
        border-radius: 50%;
      }


      img {
        width: 22px;
        height: 22px;
        // border-radius: 11px;
      }


      .red-div {
        width: 8px;
        height: 8px;
        background: #e25455;
        border-radius: 50%;
        top: 0;
        right: 0;
        position: absolute;
      }
    }
  }


  .m-user-wrapper {
    width: 21px;
    height: 21px;
    border-radius: 50%;
    overflow: hidden;


    .m-no-login {
      width: 100%;
      height: 100%;
      background: #f7e1cd;
    }


    .m-login {
      width: 100%;
      height: 100%;
      background-size: 100% 100%;
    }
  }
}


.el-drawer__wrapper {
  top: 56px;
  width: calc(100% - 51px);


  /deep/ .el-drawer__container {
    .el-drawer {
      width: 100% !important;


      .el-drawer__body {
        width: 100%;


        .item {
          height: 74px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 24px;
        }


        .market-content {
          .market-content-title {
            font-size: 16px;
            height: 42px;
            line-height: 42px;
            padding: 0 0 0 24px;
            border-bottom: 1px solid #e7e7e7;


            i {
              margin-right: 4px;
            }
          }


          .market-content-content {
            >div {
              height: 36px;
              margin-top: 15px;
              padding-left: 52px;


              img {
                width: 16px;
                margin-right: 10px;
              }


              span {
                font-size: 16px;
                color: #404040;


                &:hover {
                  color: #e8721d;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
<!-- pc -->
<style lang="scss" scoped>
nav {
  border-bottom: 1px solid #e7e7e7;
  position: sticky;
  // position: absolute;
  background-color: #fff;
  //  background: rgba($color: #000000, $alpha: 0.0);
  z-index: 3000;
  min-width: 1200px;
  width: 100%;

  &.burning {
    position: absolute;
    top: 0;
    background-color: rgba($color: #000000, $alpha: 0.0);
    border: 0;
  }

  @media screen and (max-width: 768px) {
    min-width: 100%;
  }
}


header {
  margin: 0 auto;
  max-width: 1200px;
  height: 80px;


  .phone-user {
    display: none;
  }


  .el-icon-s-unfold,
  .el-icon-s-fold {
    display: none;
  }

  .logo {
    width: 130px;
    cursor: pointer;
  }


  .hidden {
    display: none;
  }


  .link {
    .search {
      width: 314px;
      height: 47px;
      background: #f9f9f9;
      border-radius: 24px;


      i {
        color: #000;
        font-size: 20px;
        font-weight: bold;
        margin: 0 19px 0 32px;
      }


      input {
        border: 0;
        width: 200px;
        height: 100%;
        background: #f9f9f9;
        font-size: 14px;
        color: #555;
      }
    }


    .nav {
      width: 400px;
      margin: 0 55px 0 73px;



      .pointer {
        font-size: 14px;
        color: #404040;

        font-weight: 400;
        line-height: 14px;

        &.burning {
          color: #ffffff;
        }

        &:hover {
          color: #e8721d;
        }
      }


      .active {
        color: #e8721d;
      }
    }


    .user {
      width: 24px;
      height: 24px;


      img {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        cursor: pointer;
      }
    }


    .login {
      width: 56px;
      cursor: pointer;

      .burning {
        color: #fff;
      }
    }
  }
}


@media screen and (max-width: 768px) {
  header {
    min-width: 100%;
    padding: 0 20px;
    display: flex;
    justify-content: space-between !important;
    align-items: center;
    flex-direction: row-reverse;
    height: 56px;


    .el-icon-s-unfold,
    .el-icon-s-fold {
      display: block;
      font-size: 24px;
      color: rgb(138, 147, 155);
      margin-right: 6px;
    }


    .logo {
      width: 92px;
    }


    .link {


      // margin-left: auto;
      .search {
        display: none;
      }


      .nav {
        display: none;
      }


      .user {
        display: none;
      }
    }


    .phone-user {
      display: block;


      .no-login {
        width: 21px;
        height: 21px;
        background: #f7e1cd;
        border-radius: 11px;
      }


      .stationMessage {
        display: none;


        @media screen and(max-width:768px) {
          display: block;
        }


        width: 24px;
        height: 24px;
        margin-right: 20px;
        position: relative;


        .bell-icon {
          width: 18px;
          height: auto;
          cursor: pointer;


          &:hover {
            color: #e25455;
          }
        }


        .red-div {
          width: 8px;
          height: 8px;
          background: #e25455;
          border-radius: 50%;
          position: absolute;
          right: 6px;
          top: 0;
        }


        /deep/ .stationMessage-contain {
          width: 440px;
          height: auto;
          padding: 0 0 20px 0;
        }
      }


      .login {
        img {
          width: 22px;
          height: 22px;

          border-radius: 11px;
        }
      }
    }
  }


  .el-drawer__wrapper {
    top: 56px;
    width: calc(100% - 51px);


    /deep/ .el-drawer__container {
      .el-drawer {
        width: 100% !important;


        .el-drawer__body {
          width: 100%;


          .item {
            height: 74px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 24px;
          }


          .market-content {
            .market-content-title {
              font-size: 16px;
              height: 42px;
              line-height: 42px;
              padding: 0 0 0 24px;
              border-bottom: 1px solid #e7e7e7;


              i {
                margin-right: 4px;
              }
            }


            .market-content-content {
              >div {
                height: 36px;
                margin-top: 15px;
                padding-left: 52px;


                img {
                  width: 16px;
                  margin-right: 10px;
                }


                span {
                  font-size: 16px;
                  color: #404040;


                  &:hover {
                    color: #e8721d;
                  }
                }
              }
            }
          }
        }
      }


      .link {
        position: absolute;
        bottom: 20px;
        width: 100%;
        height: 120px;
        margin: 0;
        padding: 0;
        justify-content: space-around;
        display: none;


        .link-item {
          flex-direction: column;
          margin: 0;
          padding: 0;
          height: 100%;


          .icon {
            width: 30px;
            margin-bottom: 17px;
          }


          .qrcode {
            width: 80px;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.el-dropdown-menu {
  .el-dropdown-menu__item {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 16px;
    line-height: 40px !important;
    text-align: center;
    width: 100px;


    &:hover {
      background-color: #fcfaf8;
      color: #e8721d;
    }


    .icon {
      width: 23px;
      height: 22px;
      margin-right: 20px;
    }
  }


  .block {
    display: block;
    width: 120px;
    display: flex;
    justify-content: center !important;
    align-items: center;


    .link-div {
      width: 100%;
      display: flex;
      justify-content: space-between !important;
      align-items: center;
      height: 40px;


      .link {
        width: 22px;
        height: 22px;
        margin: 0;
      }


      .qq {
        background-image: url('../../../assets/images/icon/qq-link-grey-icon.png');
        background-size: 100% 100%;


        img {
          display: none;
        }


        &:hover {
          background-image: url('../../../assets/images/icon/qq-link-icon.png');


          img {
            width: 100px;
            position: relative;
            top: 30px;
            display: block;
          }
        }
      }


      .weibo {
        background-image: url('../../../assets/images/icon/weibo-link-grey-icon.png');
        background-size: 100% 100%;


        &:hover {
          background-image: url('../../../assets/images/icon/weibo-link-icon.png');
        }
      }


      .wechat {
        background-image: url('../../../assets/images/icon/wechat-link-grey-icon.png');
        background-size: 100% 100%;


        img {
          display: none;
        }


        &:hover {
          background-image: url('../../../assets/images/icon/wechat-link-icon.png');


          img {
            width: 100px;
            position: relative;
            top: 30px;
            display: block;
            left: -70px;
          }
        }
      }
    }
  }
}


.el-dropdown__popper {
  .el-dropdown-menu__item {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 16px;
    line-height: 40px;
    text-align: center;
    width: 100px;


    &:hover {
      background-color: #fcfaf8;
      color: #e8721d !important;
    }


    .icon {
      width: 23px;
      height: 22px;
      margin-right: 20px;
    }
  }
}


.el-overlay {
  top: 89px;


  .el-drawer {
    width: 100% !important;


    .market-content {
      .market-content-title {
        font-size: 16px;
        height: 42px;
        line-height: 42px;
        padding: 0 0 0 24px;
        border-bottom: 1px solid #e7e7e7;


        i {
          margin-right: 4px;
        }
      }


      .market-content-content {
        background-color: red;
        position: relative;

        >div {
          height: 36px;
          margin-top: 15px;
          padding-left: 52px;


          img {
            width: 16px;
            margin-right: 10px;
          }


          span {
            font-size: 16px;
            color: #404040;


            &:hover {
              color: #e8721d;
            }
          }
        }
      }
    }
  }
}


.stationMessage-pc {
  @media screen and(max-width:768px) {
    display: none;
  }


  width: 24px;
  height: 24px;
  margin-left: 20px;
  position: relative;


  .bell-icon {
    width: 18px;
    height: 20px;
    cursor: pointer;


    &:hover {
      color: #e25455;
    }
  }


  .red-div {
    width: 8px;
    height: 8px;
    background: #e25455;
    border-radius: 50%;
    position: absolute;
    right: 0;
    top: 0;
  }


  /deep/ .stationMessage-contain {
    width: 440px;
    height: auto;
    padding: 0 0 20px 0;
  }
}


.stationMessage-contain {
  width: 440px;
  // height: 626px;
  height: auto;
  padding: 0 0 20px 0;


  .main {
    max-width: 847px;
    margin: 0 auto;


    .title {
      font-size: 18px;
      font-weight: 500;
      color: #313131;
      line-height: 25px;
      padding-top: 26px;
      padding-left: 25px;
    }


    .tab {
      // @extend .flex-start-center;
      width: 100%;
      margin: 20px 0 0 0;
      padding: 0 25px;
      border-bottom: 1px solid #f3f3f3;


      @media screen and(max-width:768px) {
        width: 100%;
        height: 70px;
        padding: 0 20px;
        margin-right: 0;
        padding-top: 6px;
      }


      .item {
        // width: 175px;
        height: 32px;
        margin-right: 44px;
        cursor: pointer;
        position: relative;


        @media screen and(max-width:768px) {
          // width: 130px;
          margin-right: 0;
        }


        span {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #a8a8a8;
          // line-height: 40px;
          padding: 10px 0;
          position: relative;
          top: 2px;


          @media screen and(max-width:768px) {
            font-size: 13px;
            line-height: 50px;
            display: inline-block;
            text-align: center;
            width: 130px;
          }
        }


        .red {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: #e25455;
          position: absolute;
          right: -10px;
          top: 3px;
        }
      }


      .active {
        background: white;


        @media screen and(max-width:768px) {
          width: 130px;
        }

        span {
          color: #383838;
          border-bottom: 2px solid #eb7d2b;


          @media screen and(max-width:768px) {
            font-size: 14px;
            font-weight: 500;
            color: #383838;

            // line-height: 24px;
          }
        }


        // @media screen and(max-width:768px){
        background: white;
        // }
      }


      .condition {
        .condition-1 {
          font-size: 14px;
          font-weight: 400;
          color: #6b6b6b;
          line-height: 20px;
          cursor: pointer;
        }


        .condition-2 {
          width: 98px;
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #eb7d2b;
          line-height: 20px;
          text-decoration: underline;
          cursor: pointer;
          margin-left: 25px;
        }
      }
    }


    .content {
      .table {
        border-radius: 8px;
        padding: 0 20px;
        width: 100%;


        .table-content {
          .item {
            margin-top: 10px;
            cursor: pointer;
            flex-direction: column;
            border-bottom: 1px solid#EAEAEA;
            padding: 0 0 14px 0;


            .time {
              font-size: 12px;
              font-weight: 400;
              color: #aaaaaa;
              line-height: 17px;
            }


            .item-title {
              font-size: 14px;
              font-weight: 500;
              color: #3b3b3b;
              line-height: 20px;
              margin-top: 4px;
              position: relative;


              .unreadMessage {
                position: absolute;
                left: -10px;
                top: 6px;
                width: 6px;
                height: 6px;
                background: #e25455;
                border-radius: 50%;
              }
            }


            .des {
              font-size: 13px;
              font-weight: 400;
              color: #aaaaaa;
              line-height: 18px;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              margin-top: 6px;
            }
          }
        }
      }
    }


    .no-message {
      width: 387px;
      height: 432px;
      background: #f4f4f4;
      margin: 15px auto;


      span {
        font-size: 16px;
        font-weight: 400;
        color: #949494;
        line-height: 22px;
      }
    }


    .more {
      margin-top: 26px;
      cursor: pointer;


      p {
        font-size: 14px;
        font-weight: 400;
        color: #4e4e4e;
        line-height: 20px;
      }


      img {
        margin-left: 3px;
        width: 15px;
      }
    }


    .content-portfolio {
      .portfolio-title {
        // @extend .flex-between-center;
        width: 100%;
        height: 54px;

        .manage {
          font-size: 16px;
          font-weight: 500;
          color: #383838;
          line-height: 22px;
        }


        .create {
          // @extend .flex-center-center;
          width: 195px;
          height: 54px;
          background: #e8721d;
          border-radius: 8px;
          color: #fff;
          cursor: pointer;


          span {
            &:nth-child(1) {
              display: inline-block;
              height: 34px;
              line-height: 32px;
              font-size: 24px;
              margin-right: 4px;
            }


            &:nth-child(2) {
              font-size: 16px;
              line-height: 54px;
            }
          }
        }
      }


      .operate {
        // @extend .flex-between-center;
        width: 100%;
        height: 54px;
        padding: 0 55px 0 23px;
        background: #fcfaf8;
        border-radius: 2px;
        margin: 8px 0 10px 0;


        /deep/ .el-checkbox {
          .el-checkbox__label {
            color: #e8721d;
          }


          .is-checked {
            .el-checkbox__inner {
              background-color: #e8721d;
              border-color: #e8721d !important;
            }
          }


          .el-checkbox__inner {
            // background-color: #e8721d;
            border-color: #e8721d !important;
          }
        }
      }
    }


    .active-content {
      display: flex;


      .paying {
        font-size: 16px;
        font-weight: 500;
        color: #e8721d;
        line-height: 22px;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
}

.user-chuang {
  width: 64px;
  height: 32px;
  background: #E8721D;
  margin-right: 40px;
  border-radius: 3px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/cun-nav.vue